import { withErrorBoundary } from '@sentry/react'
import { Popover } from 'antd'
import { useState } from 'react'

import DotMenuIcon from 'src/assets/dot_menu.png'

import SentryFallback from './SentryFallback'

const MenuPopupWrapper = ({
    menuContent,
    children,
    trigger = 'click',
    padding,
    placement,
    domContainer = null,
    clickTestMenuPopup,
    stopPropagation = true,
    overlayStyle = {},
    className = '',
    customReferenceNode = false,
}) => {
    const [showMenu, toggleMenu] = useState(false)

    const toggleMenuVisibility = (visible) => {
        toggleMenu(visible)
    }

    const hideMenu = () => {
        toggleMenu(false)
    }

    const popupContainer = () => {
        if (customReferenceNode) {
            return (triggerNode) =>
                domContainer && domContainer.current
                    ? domContainer.current
                    : triggerNode.parentNode
        } else {
            if (domContainer && domContainer.current) {
                return () => domContainer.current
            } else {
                return undefined
            }
        }
    }

    return (
        <Popover
            content={() => (
                <div
                    onClick={(e) => {
                        stopPropagation && e.stopPropagation()
                        hideMenu()
                    }}
                >
                    {menuContent}
                </div>
            )}
            // on
            placement={placement || 'bottom'}
            color="#2F3B52"
            trigger={trigger}
            open={showMenu}
            onOpenChange={toggleMenuVisibility}
            // provide a root for the menu to attach to
            // prevents menu from scrolling up when opened from fixed elements i.e Header etc
            getPopupContainer={popupContainer()}
            overlayStyle={overlayStyle}
        >
            {children ? (
                <div>{children}</div>
            ) : (
                <img
                    className={`menu-popup mx-auto cursor-pointer 2xl:py-3 ${className}`}
                    style={{ padding: padding || '8px 16px 8px 0px' }}
                    alt="menu"
                    src={DotMenuIcon}
                    onClick={(e) => {
                        e.stopPropagation()
                        toggleMenu(true)
                    }}
                    data-testid={clickTestMenuPopup}
                ></img>
            )}
        </Popover>
    )
}

export default withErrorBoundary(MenuPopupWrapper, {
    fallback: <SentryFallback />,
})
